import { render, staticRenderFns } from "./batchInfo.vue?vue&type=template&id=1ab3f0d6"
import script from "./batchInfo.vue?vue&type=script&lang=js"
export * from "./batchInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports